import effects from 'app/effects/effects'
import { getAllGroups } from 'app/store/groups'
import { useDispatch } from 'react-redux'

export const useGroups = () => {
  const dispatch = useDispatch()

  const fetchAllGroups = async (params = { limit: 1000 }) => {
    await effects.apis
      .groupsWithTagsWithOutType(params)
      .then((response) => {
        dispatch(getAllGroups(response))
      })
      .catch((error) => {
        return error
      })
  }
  return {
    fetchAllGroups,
  }
}
